import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router.js'
import axios from 'axios'
import store from '@/store'
import titleMixin from './utilities/title';
import CUSTOMER from '@/consts/customer.js';
import VueToastr from "vue-toastr";
import Store from '@/store';
import './assets/styles.css';
import Swal from 'sweetalert2';

const createAxios = (baseURL) => {
    const axiosInstance = axios.create({ baseURL })
    axiosInstance.interceptors.request.use((request) => {
        if (store.state && store.state.token) {
            request.headers["token"] = store.state.token;
        }
        return request;
    });
    axiosInstance.interceptors.response.use(response => {
        return response
    }, error => {
        if (!error.response) {
            alert('サーバーに接続できませんでした。しばらくしてからもう一度お試しください。')
            return Promise.reject(error)
        }
        if (error.response.status == 492) {
            let  errorMsg = '同じ時間帯に複数の予定を登録することはできません。';
            if (error.response.data.conflictingAppointmentRes) {
                const { firstErrorMsg, kind, targetTime, targetTimeEnd, counselorName, boothNoName, customerName } = error.response.data.conflictingAppointmentRes;
                errorMsg += `<p>${firstErrorMsg}</p>`;
                errorMsg += `<p style="font-weight: bold;">${CUSTOMER.EXEC_KIND.getName(kind)}</p>`;
                errorMsg += `<p>時間：${targetTime.slice(0, -3)}〜${targetTimeEnd.slice(0, -3)}</p>`;
                errorMsg += `<p>${customerName}</p>`;
                errorMsg += `<p>担当：${counselorName}</p>`;
                errorMsg += `<p>ブース：${boothNoName}</p>`;
            }
            Swal.fire({
                html: `<div style="text-align: left; color: #000000de; font-size: 14px; font-family: 'Roboto';">${errorMsg}</div>`,
                confirmButtonText: `<span style="font-size: 14px;">OK</span>`,
                confirmButtonColor: "#1e88e5",
                color: '#ffffff'
            });
            return Promise.reject(error)
        }

        if (error.response.status == 401) {
            Store.dispatch("reset")
            return router.go('/login');
        }
        alert('エラーが発生しました。もう一度お試しください。')
        return Promise.reject(error)
        // location.href = "/logout";
    })
    return axiosInstance;
}

(async () => {
    Vue.config.productionTip = false
    Vue.mixin(titleMixin);

    Vue.use({
        install(Vue) {
            Vue.prototype.$axios = createAxios(process.env.VUE_APP_BASE_URL);
            Vue.prototype.$cshipApi = createAxios(`https://test-api-developers.c-ship.jp/`);
        }
    })
    Vue.use(VueToastr, {
        defaultTimeout: 1000,
        defaultProgressBar: false,
        defaultIcon: false,
    });
    if (store.isExpire() && store.state.user.id && store.state.token) {
        await Vue.prototype.$axios.get(`/api/v1/auth/reload/${store.state.user.id}`)
            .then(res => {
                const user = res.data.user
                const token = store.state.token;
                store.dispatch("fetch", { user, token });
            })
            .catch(err => console.log(err));
    }

    new Vue({
        vuetify,
        router,
        store,
        render: h => h(App)
    }).$mount('#app')
})();